import { deprecated } from "typesafe-actions";

import type { IPaperMachineInfo } from "@/shop/types/personalized/originalSupply";

import { OriginalSupplyActions } from "./constants";

const { createStandardAction } = deprecated;

export const fetchMachines = createStandardAction(OriginalSupplyActions.FETCH_MACHINES)();

export const fetchMachinesStart = createStandardAction(OriginalSupplyActions.FETCH_MACHINES_START)();

export const fetchMachinesFail = createStandardAction(OriginalSupplyActions.FETCH_MACHINES_FAIL).map((err: Error) => ({
  payload: err,
  error: true
}));

export const fetchMachinesSuccess = createStandardAction(OriginalSupplyActions.FETCH_MACHINES_SUCCESS).map((payload: IPaperMachineInfo[]) => ({
  payload
}));
